import CardKit from "@/shared/components/kit/card";
/**
 * Slider
 *
 * کامپوننت اسلایدر که یک تصویر ثابت را درون کارت نمایش می‌دهد.
 *
 * @returns JSX.Element
 */

const Slider = () => {
  return (
    <CardKit
      width={"100%"}
      height={410}
      sx={{ padding: 0, overflow: "hidden", position: "relative" }}
    >
      <img
        src={"/slider3.jpg"}
        alt="slider"
        style={{
          width: "100%",
          height: "409px",
          objectFit: "cover",
          display: "block",
          position: "absolute",
          bottom: 0,
          top: 0,
          left: 0,
        }}
      />
    </CardKit>
  );
};

export default Slider;
